import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getPropiedad, registrarVisita } from "../../firebase/propiedades";
import logo from "../../logo.png";

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 768 : false
  );
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);
  return isMobile;
}

export default function Detalle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [propiedad, setPropiedad] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [indice, setIndice] = useState(0);
  const [modal, setModal] = useState(false);

  useEffect(() => {
  getPropiedad(id).then((data) => {
    setPropiedad(data);
    setCargando(false);
  });
  registrarVisita(id);
}, [id]);

  if (cargando) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <p style={{ color: "#9ca3af", fontSize: "14px" }}>Cargando propiedad...</p>
      </div>
    );
  }

  if (!propiedad) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <p style={{ color: "#9ca3af" }}>Propiedad no encontrada.</p>
      </div>
    );
  }

  const imagenes = propiedad.imagenes || (propiedad.imagen ? [propiedad.imagen] : []);
  const tituloEnc = encodeURIComponent(propiedad.titulo);
  const whatsappUrl = "https://wa.me/5493456458348?text=Hola%2C%20me%20interesa%20la%20propiedad%20*" + tituloEnc + "*%20que%20vi%20en%20su%20web.";
  const whatsappPrecioUrl = "https://wa.me/5493456458348?text=Hola%2C%20me%20interesa%20la%20propiedad%20*" + tituloEnc + "*%20y%20quisiera%20consultar%20el%20precio.";

  const tieneServicios = propiedad.asfalto || propiedad.gasNatural;

  const abrirWhatsapp = (url) => window.open(url, "_blank", "noopener,noreferrer");

  return (
    <div style={{ minHeight: "100vh", background: "#ffffff", fontFamily: "system-ui, sans-serif" }}>

      <nav style={{
        background: "#f4f4f4",
        borderBottom: "1px solid #e5e5e5",
        padding: "12px 20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        position: "sticky",
        top: 0,
        zIndex: 100,
        gap: "8px",
      }}>
        <img
          src={logo}
          alt="Confalonieri Propiedades"
          onClick={() => navigate("/")}
          style={{ height: "40px", cursor: "pointer" }}
        />
        <button
          onClick={() => navigate("/propiedades")}
          style={{
            background: "none",
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            padding: isMobile ? "6px 10px" : "8px 16px",
            color: "#6b7280",
            fontSize: isMobile ? "11px" : "13px",
            cursor: "pointer",
            whiteSpace: "nowrap",
          }}
        >
          {isMobile ? "Volver" : "Volver al listado"}
        </button>
      </nav>

      <div style={{ height: "4px", background: "#1a9e2a" }} />

      <div style={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: isMobile ? "20px 16px" : "40px 24px",
      }}>

        <div style={{ marginBottom: isMobile ? "28px" : "40px" }}>
          <div style={{ borderRadius: "16px", overflow: "hidden", background: "#f9fafb", position: "relative", marginBottom: "12px" }}>
            {imagenes.length > 0 ? (
              <>
                <img
                  src={imagenes[indice]}
                  alt={propiedad.titulo}
                  onClick={() => setModal(true)}
                  style={{
                    width: isMobile ? "100%" : "50%",
                    height: "auto",
                    display: "block",
                    cursor: "zoom-in",
                    margin: "0 auto",
                  }}
                />
                {imagenes.length > 1 && (
                  <>
                    <button
                      onClick={() => setIndice((indice - 1 + imagenes.length) % imagenes.length)}
                      style={{
                        position: "absolute",
                        left: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        background: "rgba(255,255,255,0.9)",
                        border: "none",
                        borderRadius: "50%",
                        width: isMobile ? "40px" : "36px",
                        height: isMobile ? "40px" : "36px",
                        fontSize: "20px",
                        cursor: "pointer",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                      }}
                    >
                      {"<"}
                    </button>
                    <button
                      onClick={() => setIndice((indice + 1) % imagenes.length)}
                      style={{
                        position: "absolute",
                        right: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        background: "rgba(255,255,255,0.9)",
                        border: "none",
                        borderRadius: "50%",
                        width: isMobile ? "40px" : "36px",
                        height: isMobile ? "40px" : "36px",
                        fontSize: "20px",
                        cursor: "pointer",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                      }}
                    >
                      {">"}
                    </button>
                    <span style={{
                      position: "absolute",
                      bottom: "12px",
                      right: "12px",
                      background: "rgba(0,0,0,0.45)",
                      color: "#fff",
                      fontSize: "11px",
                      padding: "4px 10px",
                      borderRadius: "20px",
                    }}>
                      {indice + 1} / {imagenes.length}
                    </span>
                  </>
                )}
              </>
            ) : (
              <div style={{ height: "300px", display: "flex", alignItems: "center", justifyContent: "center", color: "#9ca3af" }}>
                Sin fotos
              </div>
            )}
          </div>

          {imagenes.length > 1 && (
            <div style={{ display: "flex", gap: "8px", overflowX: "auto", paddingBottom: "4px" }}>
              {imagenes.map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt=""
                  onClick={() => setIndice(i)}
                  style={{
                    width: isMobile ? "64px" : "72px",
                    height: isMobile ? "64px" : "72px",
                    objectFit: "cover",
                    borderRadius: "8px",
                    cursor: "pointer",
                    flexShrink: 0,
                    border: i === indice ? "2px solid #1a3c5e" : "2px solid transparent",
                    opacity: i === indice ? 1 : 0.6,
                    transition: "all 0.2s",
                  }}
                />
              ))}
            </div>
          )}
        </div>

        <div style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "1fr 300px",
          gap: isMobile ? "24px" : "40px",
          alignItems: "start",
        }}>

          <div>
            <div style={{ display: "flex", gap: "8px", marginBottom: "16px", flexWrap: "wrap" }}>
              {propiedad.operacion && (
                <span style={{ background: "#1a3c5e", color: "#fff", fontSize: "11px", padding: "4px 12px", borderRadius: "20px", fontWeight: "600" }}>
                  {propiedad.operacion}
                </span>
              )}
              {propiedad.tipo && (
                <span style={{ background: "#f3f4f6", color: "#374151", fontSize: "11px", padding: "4px 12px", borderRadius: "20px", fontWeight: "600" }}>
                  {propiedad.tipo}
                </span>
              )}
              {propiedad.estado && propiedad.estado !== "Disponible" && (
                <span style={{ background: "#fee2e2", color: "#dc2626", fontSize: "11px", padding: "4px 12px", borderRadius: "20px", fontWeight: "600" }}>
                  {propiedad.estado}
                </span>
              )}
            </div>

            <h1 style={{
              fontSize: isMobile ? "22px" : "28px",
              fontWeight: "700",
              color: "#111827",
              marginBottom: "8px",
              lineHeight: "1.2",
              wordBreak: "break-word",
            }}>
              {propiedad.titulo}
            </h1>

            <p style={{ color: "#6b7280", fontSize: isMobile ? "13px" : "14px", marginBottom: "20px" }}>
              {propiedad.ubicacion}{propiedad.barrio ? " - " + propiedad.barrio : ""}
            </p>

            {propiedad.precio ? (
              <p style={{
                fontSize: isMobile ? "26px" : "32px",
                fontWeight: "700",
                color: "#1a3c5e",
                marginBottom: "24px",
                wordBreak: "break-word",
              }}>
                ${propiedad.precio.toLocaleString()}
              </p>
            ) : (
              <button
                onClick={() => abrirWhatsapp(whatsappPrecioUrl)}
                style={{
                  display: isMobile ? "block" : "inline-block",
                  width: isMobile ? "100%" : "auto",
                  textAlign: "center",
                  background: "#25d366",
                  color: "#fff",
                  fontSize: "15px",
                  padding: "12px 24px",
                  borderRadius: "12px",
                  fontWeight: "700",
                  border: "none",
                  cursor: "pointer",
                  marginBottom: "24px",
                }}
              >
                Consultar precio por WhatsApp
              </button>
            )}

            {(propiedad.ambientes || propiedad.superficie) && (
              <div style={{
                display: "flex",
                gap: isMobile ? "12px" : "24px",
                flexWrap: "wrap",
                justifyContent: isMobile ? "space-around" : "flex-start",
                marginBottom: "20px",
                padding: "16px",
                background: "#f9fafb",
                borderRadius: "12px",
              }}>
                {propiedad.ambientes && (
                  <div style={{ textAlign: "center" }}>
                    <div style={{ fontSize: "13px", fontWeight: "600", color: "#111827" }}>
                      {propiedad.ambientes}
                    </div>
                    <div style={{ fontSize: "11px", color: "#9ca3af" }}>dormitorios</div>
                  </div>
                )}
                {propiedad.superficie && (
                  <div style={{ textAlign: "center" }}>
                    <div style={{ fontSize: "13px", fontWeight: "600", color: "#111827" }}>
                      {propiedad.superficie} m2
                    </div>
                    <div style={{ fontSize: "11px", color: "#9ca3af" }}>superficie</div>
                  </div>
                )}
              </div>
            )}

            {tieneServicios && (
              <div style={{ marginBottom: "28px" }}>
                <h3 style={{ fontSize: "13px", fontWeight: "700", color: "#6b7280", marginBottom: "10px", letterSpacing: "0.5px" }}>
                  SERVICIOS
                </h3>
                <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                  {propiedad.asfalto && (
                    <span style={{ background: "#f0fdf4", color: "#166534", fontSize: "13px", padding: "8px 14px", borderRadius: "20px", fontWeight: "600", border: "1px solid #bbf7d0" }}>
                      Asfalto
                    </span>
                  )}
                  {propiedad.gasNatural && (
                    <span style={{ background: "#f0fdf4", color: "#166534", fontSize: "13px", padding: "8px 14px", borderRadius: "20px", fontWeight: "600", border: "1px solid #bbf7d0" }}>
                      Gas natural
                    </span>
                  )}
                </div>
              </div>
            )}

            {propiedad.descripcion && (
              <div>
                <h3 style={{ fontSize: "15px", fontWeight: "600", color: "#111827", marginBottom: "8px" }}>
                  Descripcion
                </h3>
                <p style={{ color: "#6b7280", fontSize: "14px", lineHeight: "1.7", whiteSpace: "pre-wrap" }}>
                  {propiedad.descripcion}
                </p>
              </div>
            )}
          </div>

          <div style={{
            background: "#f9fafb",
            borderRadius: "16px",
            padding: isMobile ? "20px" : "24px",
            position: isMobile ? "static" : "sticky",
            top: "80px",
          }}>
            <h3 style={{ fontSize: "16px", fontWeight: "700", color: "#111827", marginBottom: "8px" }}>
              Te interesa esta propiedad?
            </h3>
            <p style={{ fontSize: "13px", color: "#6b7280", marginBottom: "20px", lineHeight: "1.6" }}>
              Contactanos directamente por WhatsApp y te respondemos a la brevedad.
            </p>
            <button
              onClick={() => abrirWhatsapp(whatsappUrl)}
              style={{
                display: "block",
                width: "100%",
                textAlign: "center",
                background: "#25d366",
                color: "#fff",
                borderRadius: "10px",
                padding: "14px",
                fontWeight: "600",
                fontSize: "15px",
                border: "none",
                cursor: "pointer",
              }}
            >
              Consultar por WhatsApp
            </button>
          </div>

        </div>
      </div>

      {modal && (
        <div
          onClick={() => setModal(false)}
          style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.92)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 999 }}
        >
          <img
            src={imagenes[indice]}
            alt=""
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: "92%", maxHeight: "85%", objectFit: "contain", borderRadius: "8px" }}
          />
          {imagenes.length > 1 && (
            <>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setIndice((indice - 1 + imagenes.length) % imagenes.length);
                }}
                style={{
                  position: "absolute",
                  left: isMobile ? "10px" : "20px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "rgba(255,255,255,0.15)",
                  border: "none",
                  borderRadius: "50%",
                  width: isMobile ? "44px" : "48px",
                  height: isMobile ? "44px" : "48px",
                  fontSize: "24px",
                  color: "#fff",
                  cursor: "pointer",
                }}
              >
                {"<"}
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setIndice((indice + 1) % imagenes.length);
                }}
                style={{
                  position: "absolute",
                  right: isMobile ? "10px" : "20px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "rgba(255,255,255,0.15)",
                  border: "none",
                  borderRadius: "50%",
                  width: isMobile ? "44px" : "48px",
                  height: isMobile ? "44px" : "48px",
                  fontSize: "24px",
                  color: "#fff",
                  cursor: "pointer",
                }}
              >
                {">"}
              </button>
            </>
          )}
          <span style={{
            position: "absolute",
            bottom: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            background: "rgba(0,0,0,0.5)",
            color: "#fff",
            fontSize: "12px",
            padding: "4px 12px",
            borderRadius: "20px",
          }}>
            {indice + 1} / {imagenes.length}
          </span>
          <button
            onClick={() => setModal(false)}
            style={{
              position: "absolute",
              top: "16px",
              right: "16px",
              background: "rgba(0,0,0,0.4)",
              border: "none",
              borderRadius: "50%",
              width: "40px",
              height: "40px",
              color: "#fff",
              fontSize: "22px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            X
          </button>
        </div>
      )}

      <footer style={{
        borderTop: "3px solid #1a9e2a",
        padding: isMobile ? "20px 16px" : "24px",
        textAlign: "center",
        color: "#9ca3af",
        fontSize: isMobile ? "12px" : "13px",
        marginTop: "60px",
        background: "#f4f4f4",
      }}>
        Confalonieri Propiedades - Sarmiento 2750, Chajari - Todos los derechos reservados
      </footer>

    </div>
  );
}